import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
  query LgcaAcHeaderNavQuery {
    craft {
      globalSet(handle: "header", site: "lgcaAc") {
        ... on Craft_header_GlobalSet {
          name
          navHeading
          navCopy
          heading0
          navCampaigns {
            ... on Craft_navCampaigns_campaign_BlockType {
              uid
              enabled
              campaign(site: "*") {
                url
                slug
                title
                ... on Craft_issue_issue_Entry {
                  heading0
                }
              }
            }
          }
          linkList {
            ... on Craft_linkList_action_BlockType {
              uid
              enabled
              action {
                url
              }
              linkText
            }
            ... on Craft_linkList_listLink_BlockType {
              uid
              enabled
              linkText
              listLink {
                url
              }
            }
          }
          secondaryNav {
            ... on Craft_secondaryNav_navLink_BlockType {
              uid
              enabled
              navLink {
                url
              }
              linkText
            }
          }
        }
      }
    }
  }
`;

const dataResolver = ({ craft }) => {
  const {
    navHeading,
    navCopy,
    navCampaigns,
    secondaryNav,
    linkList,
    heading0,
  } = craft.globalSet;
  return {
    heading: navHeading,
    copy: navCopy,
    campaignsHeading: heading0,
    campaigns: navCampaigns
      .filter(c => c.campaign[0])
      .map(c => {
        return {
          uid: c.uid,
          path: c.campaign[0].url || `/${c.campaign[0].slug}`,
          heading: c.campaign[0]?.heading0 || c.campaign[0].title,
          url: c.campaign[0].url || `/${c.campaign[0].slug}`,
          text: c.campaign[0]?.heading0 || c.campaign[0].title,
        };
      }),
    primaryNav: linkList.map(item => {
      return {
        uid: item.uid,
        link:
          item.action && item.action.length
            ? item.action[0].url
            : item.listLink?.url,
        text: item.linkText,
      };
    }),
    secondaryNav: secondaryNav.map(link => {
      return {
        uid: link.uid,
        link: link.navLink?.url,
        text: link.linkText,
      };
    }),
  };
};

const useData = () => {
  const response = useStaticQuery(query);
  return dataResolver(response);
};

export default useData;
